import type { MarketplaceOrderHandoffDefaultItemMeta } from './marketplace-order-handoff-defaults.js';

export type HandoffDefaultSource = 'Per order' | 'Package' | 'Folder';

export const HANDOFF_SOURCE_MEANINGS: Record<HandoffDefaultSource, string> = {
  'Per order': 'Written for this specific order. This is the real authoring workload.',
  Package: 'Comes from the selected package and is constant across every order under it.',
  Folder: 'A URL or the text itself. We store the string only — not files.',
};

const URL_PATTERN = /^https?:\/\/\S+$/i;

export function looksLikeHandoffUrl(value: string): boolean {
  return URL_PATTERN.test(value.trim());
}

/** Folder values are a URL or free text. Files are not stored. */
export function formatFolderPointerText(value: string): string {
  return value.trim();
}

export function resolvePackageProductAccuracy(
  packageSnapshot: { description?: string | null } | null | undefined,
): string {
  return packageSnapshot?.description?.trim() ?? '';
}

export function shouldRenderHandoffDefaultItem(
  meta: MarketplaceOrderHandoffDefaultItemMeta,
  value: string,
): boolean {
  return value.trim().length > 0;
}

export function isOrgConfigurableHandoffDefault(
  meta: MarketplaceOrderHandoffDefaultItemMeta,
): boolean {
  return meta.source === 'Folder' || meta.source === 'Package';
}
